import { IconButton } from '@material-ui/core';
import React from 'react';
import breakpoint from '../helpers/breakpoints';
import slackIcon from '../images/slack.png';
import TelegramIcon from '@material-ui/icons/Telegram';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';

const Footer = () => {
    return <footer className={['XL', 'L'].includes(breakpoint()) ? 'footer' : 'mobile-footer'}>
        <div className={['XL', 'L'].includes(breakpoint()) ? 'footer-item' : 'mb-1 mt-1'}>
            <span>© TechStart.dev Inc. All rights reserved.</span>
        </div>
        <div className={['XL', 'L'].includes(breakpoint()) ? 'footer-item' : 'mb-1 mt-1'}>
            <span>
                <a href="https://www.techstart.dev/privacy-policy" rel="noopener noreferrer" target="_blank">
                    Privacy Policy
                </a>
            </span>
        </div>
        <div className='mt-1 mb-1'>
            <IconButton href='https://t-start.slack.com' rel="noopener noreferrer" target="_blank">
                <img style={{ height: '1.165rem', width: '1.165rem', opacity: '0.5' }} src={slackIcon} alt='slack' />
            </IconButton>
            <IconButton href='https://t.me/techstartdev' rel="noopener noreferrer" target="_blank"><TelegramIcon /></IconButton>
            <IconButton href='https://www.instagram.com/techstart.dev/' rel="noopener noreferrer" target="_blank"><InstagramIcon /></IconButton>
            <IconButton href='https://www.facebook.com/techstart.dev/' rel="noopener noreferrer" target="_blank"><FacebookIcon /></IconButton>
        </div>
    </footer >
}

export default Footer